import { utcNow, parse } from "../fable_modules/fable-library.3.7.20/DateOffset.js";
import { toString as toString_1, parse as parse_1 } from "../fable_modules/fable-library.3.7.20/DateOnly.js";
import { toString } from "../fable_modules/fable-library.3.7.20/Date.js";
import { toList, tryFind, map as map_1, isEmpty, choose } from "../fable_modules/fable-library.3.7.20/Seq.js";
import { some, value as value_3, defaultArgWith, map } from "../fable_modules/fable-library.3.7.20/Option.js";
import { toFail, substring, split, endsWith, printf, toText, join } from "../fable_modules/fable-library.3.7.20/String.js";
import { equalsWith, map as map_2 } from "../fable_modules/fable-library.3.7.20/Array.js";
import { fold, map as map_3 } from "../fable_modules/fable-library.3.7.20/List.js";
import { record_type, lambda_type, string_type, class_type } from "../fable_modules/fable-library.3.7.20/Reflection.js";
import { isMatch, create } from "../fable_modules/fable-library.3.7.20/RegExp.js";
import { Record } from "../fable_modules/fable-library.3.7.20/Types.js";
import { HttpResponse__EnsureSuccessStatusCode, HttpRequest__SendAsync_Z524259A4, HttpRequestModule_create, HttpRequest__SetHeader_Z384F8060, HttpResponse__AsUtf8String, HttpResponse$reflection, HttpRequest$reflection } from "../fable_modules/Fenix.Dry.Fable.60.0.3/Http2.fs.js";
import { JSInt, JSObj_ofList, JSVal, JSObject__tryFind_Z721C83C5, $007CJSInt$007C_$007C, stringToJson, jsonToString, JSVal$reflection } from "../fable_modules/Svea.Dry.Fable.1.0.4/JSON.fs.js";
import { get_UTF8 } from "../fable_modules/fable-library.3.7.20/Encoding.js";
import { singleton } from "../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { runSynchronously } from "../fable_modules/fable-library.3.7.20/Async.js";
import { Lazy } from "../fable_modules/fable-library.3.7.20/Util.js";
import { parse as parse_2 } from "../fable_modules/fable-library.3.7.20/Decimal.js";
import { toString as toString_2, parse as parse_3 } from "../fable_modules/fable-library.3.7.20/Long.js";

export function Format_dateTime(str) {
    return parse(str);
}

export function Format_date(str) {
    return parse_1(str);
}

export function Unformat_dateTime(d) {
    let copyOfStruct = utcNow();
    return toString(copyOfStruct, "o", {});
}

export function Unformat_date(d) {
    return toString_1(d);
}

export function templateUrl(templated, keys, querystrings) {
    let qs;
    const q = choose((tupledArg) => map((v) => [tupledArg[0], v], tupledArg[1]), querystrings);
    if (isEmpty(q)) {
        qs = "";
    }
    else {
        const arg_2 = join("\u0026", map_1((tupledArg_1) => toText(printf("%s=%s"))(tupledArg_1[0])(tupledArg_1[1]), q));
        qs = toText(printf("?%s"))(arg_2);
    }
    return join("/", map_2((x) => {
        if ((x.indexOf("{") === 0) && endsWith(x, "}")) {
            let key_2;
            const matchValue = split(substring(x, 1, x.length - 2), [":"], 2, 0);
            key_2 = (((!equalsWith((x_1, y) => (x_1 === y), matchValue, null)) && (matchValue.length === 2)) ? matchValue[0] : (((!equalsWith((x_2, y_1) => (x_2 === y_1), matchValue, null)) && (matchValue.length === 1)) ? matchValue[0] : toFail(printf("Unexpected length of array %A"))(matchValue)));
            return defaultArgWith(tryFind((tupledArg_2) => (tupledArg_2[0] === key_2), keys), () => toFail(printf("Key \u0027%s\u0027 not found"))(key_2))[1];
        }
        else {
            return x;
        }
    }, split(templated, ["/"], null, 0))) + qs;
}

export function asStr(s) {
    return s.FormatToString();
}

function asList(items, mapper) {
    return join(",", map_3(mapper, items));
}

export class Required {
    constructor() {
    }
}

export function Required$reflection() {
    return class_type("Library.Required", void 0, Required);
}

export function Required_$ctor() {
    return new Required();
}

export function Required_AsString_Z721C83C5(str) {
    return str;
}

export function Required_AsString_Z524259A4(i) {
    return toText(printf("%i"))(i);
}

export function Required_AsString_Z524259C1(i) {
    return toText(printf("%i"))(i);
}

export function Required_AsString_Z1FBCCD16(i) {
    return toText(printf("%b"))(i);
}

export function Required_AsString_32C73145(i) {
    return toText(printf("%M"))(i);
}

export function Required_AsString_244AC511(i) {
    return i;
}

export function Required_AsString_Z53C0511E(i) {
    return Unformat_dateTime(i);
}

export function Required_AsString_5C6E3E46(i) {
    let copyOfStruct = i;
    return copyOfStruct.FormatToString();
}

export function Required_AsString_1334CEF1(str) {
    return asList(str, Required_AsString_Z721C83C5);
}

export function Required_AsString_Z3DDD5B6A(i) {
    return asList(i, Required_AsString_Z524259A4);
}

export function Required_AsString_Z3DDD572B(i) {
    return asList(i, Required_AsString_Z524259C1);
}

export function Required_AsString_Z41714AE0(i) {
    return asList(i, Required_AsString_Z1FBCCD16);
}

export function Required_AsString_2D52035B(i) {
    return asList(i, Required_AsString_244AC511);
}

export function Required_AsString_Z6CF68354(i) {
    return asList(i, Required_AsString_5C6E3E46);
}

function opt(value, fn) {
    if (value != null) {
        return some(fn(value_3(value)));
    }
    else {
        return void 0;
    }
}

export class Optional {
    constructor() {
    }
}

export function Optional$reflection() {
    return class_type("Library.Optional", void 0, Optional);
}

export function Optional_$ctor() {
    return new Optional();
}

export function Optional_AsString_2297AD2E(str) {
    return opt(str, Required_AsString_Z721C83C5);
}

export function Optional_AsString_4019FA9(i) {
    return opt(i, Required_AsString_Z524259A4);
}

export function Optional_AsString_4018BEA(i) {
    return opt(i, Required_AsString_Z524259C1);
}

export function Optional_AsString_73E1A31F(i) {
    return opt(i, Required_AsString_Z1FBCCD16);
}

export function Optional_AsString_Z2F9AE9BC(i) {
    return opt(i, Required_AsString_244AC511);
}

export function Optional_AsString_57B7DC57(i) {
    return opt(i, Required_AsString_Z53C0511E);
}

export function Optional_AsString_Z486118D(i) {
    return opt(i, Required_AsString_5C6E3E46);
}

export function Optional_AsString_4A2B2B24(str) {
    return opt(str, Required_AsString_1334CEF1);
}

export function Optional_AsString_Z412B8CDD(i) {
    return opt(i, Required_AsString_Z3DDD5B6A);
}

export function Optional_AsString_Z4128DFC0(i) {
    return opt(i, Required_AsString_Z3DDD572B);
}

export function Optional_AsString_Z567A96EB(i) {
    return opt(i, Required_AsString_Z41714AE0);
}

export function Optional_AsString_Z570FE132(i) {
    return opt(i, Required_AsString_2D52035B);
}

export function Optional_AsString_Z6E92F8E7(i) {
    return opt(i, Required_AsString_Z6CF68354);
}

export function Optional_AsString_Z721C83C5(str) {
    return str;
}

export function Optional_AsString_Z524259A4(i) {
    return toText(printf("%i"))(i);
}

export function Optional_AsString_Z524259C1(i) {
    return toText(printf("%i"))(i);
}

export function Optional_AsString_Z1FBCCD16(i) {
    return toText(printf("%b"))(i);
}

export function Optional_AsString_244AC511(i) {
    return i;
}

export function Optional_AsString_5C6E3E46(i) {
    let copyOfStruct;
    return (copyOfStruct = i, copyOfStruct.FormatToString());
}

export function Optional_AsString_1334CEF1(str) {
    return asList(str, Required_AsString_Z721C83C5);
}

export function Optional_AsString_Z3DDD5B6A(i) {
    return asList(i, Required_AsString_Z524259A4);
}

export function Optional_AsString_Z3DDD572B(i) {
    return asList(i, Required_AsString_Z524259C1);
}

export function Optional_AsString_Z41714AE0(i) {
    return asList(i, Required_AsString_Z1FBCCD16);
}

export function Optional_AsString_2D52035B(i) {
    return asList(i, Required_AsString_244AC511);
}

export function Optional_AsString_Z6CF68354(i) {
    return asList(i, Required_AsString_5C6E3E46);
}

export class RegexStringCreator$1 {
    constructor(pattern, mapper) {
        this.pattern = pattern;
        this.mapper = mapper;
        this.regex = create(this.pattern);
    }
}

export function RegexStringCreator$1$reflection(gen0) {
    return class_type("Library.RegexStringCreator`1", [gen0], RegexStringCreator$1);
}

export function RegexStringCreator$1_$ctor_25EC9946(pattern, mapper) {
    return new RegexStringCreator$1(pattern, mapper);
}

export function RegexStringCreator$1__IsValid_Z721C83C5(x, str) {
    return isMatch(x.regex, str);
}

export function RegexStringCreator$1__CreateOrFail_Z721C83C5(x, str) {
    if (RegexStringCreator$1__IsValid_Z721C83C5(x, str)) {
        return x.mapper([true, str]);
    }
    else {
        return toFail(printf("Could not create from \u0027%s\u0027 matching regexp %s"))(str)(x.pattern);
    }
}

export function RegexStringCreator$1__ForceCreate_Z721C83C5(x, str) {
    return x.mapper([RegexStringCreator$1__IsValid_Z721C83C5(x, str), str]);
}

export function RegexStringCreator$1__TryCreate_Z721C83C5(x, str) {
    if (RegexStringCreator$1__IsValid_Z721C83C5(x, str)) {
        return some(x.mapper([true, str]));
    }
    else {
        return void 0;
    }
}

export class SveaDry_Dependency extends Record {
    constructor(BaseAddress, PreSend, PostSend) {
        super();
        this.BaseAddress = BaseAddress;
        this.PreSend = PreSend;
        this.PostSend = PostSend;
    }
}

export function SveaDry_Dependency$reflection() {
    return record_type("Library.SveaDry.Dependency", [], SveaDry_Dependency, () => [["BaseAddress", string_type], ["PreSend", lambda_type(HttpRequest$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [HttpRequest$reflection()]))], ["PostSend", lambda_type(HttpRequest$reflection(), lambda_type(HttpResponse$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [HttpResponse$reflection()])))]]);
}

export class SveaDry_WriteContainer extends Record {
    constructor(Node$) {
        super();
        this.Node = Node$;
    }
}

export function SveaDry_WriteContainer$reflection() {
    return record_type("Library.SveaDry.WriteContainer", [], SveaDry_WriteContainer, () => [["Node", JSVal$reflection()]]);
}

export class SveaDry_ResponseContainer extends Record {
    constructor(Response) {
        super();
        this.Response = Response;
    }
}

export function SveaDry_ResponseContainer$reflection() {
    return record_type("Library.SveaDry.ResponseContainer", [], SveaDry_ResponseContainer, () => [["Response", HttpResponse$reflection()]]);
}

export function SveaDry_ResponseContainer__get_StatusCode(x) {
    return x.Response.Status;
}

export function SveaDry_ResponseContainer__get_AsString(x) {
    return HttpResponse__AsUtf8String(x.Response);
}

export class SveaDry_ElementContainer extends Record {
    constructor(Node$, ResponseContainer) {
        super();
        this.Node = Node$;
        this.ResponseContainer = ResponseContainer;
    }
}

export function SveaDry_ElementContainer$reflection() {
    return record_type("Library.SveaDry.ElementContainer", [], SveaDry_ElementContainer, () => [["Node", class_type("System.Lazy`1", [JSVal$reflection()])], ["ResponseContainer", SveaDry_ResponseContainer$reflection()]]);
}

export function SveaDry_sendAsync(dep, method, headers, url, jsNode) {
    let arg, objectArg;
    const req_2 = fold((req_1, tupledArg) => {
        const value = tupledArg[1];
        if (value == null) {
            return req_1;
        }
        else {
            return HttpRequest__SetHeader_Z384F8060(req_1, tupledArg[0], value);
        }
    }, HttpRequestModule_create(method, dep.BaseAddress + url, "application/Json", (jsNode == null) ? (new Uint8Array([])) : ((arg = jsonToString(jsNode.Node), (objectArg = get_UTF8(), objectArg.getBytes(arg))))), headers);
    return singleton.Delay(() => singleton.Bind(dep.PreSend(req_2), (_arg) => {
        const req_3 = _arg;
        return singleton.Bind(HttpRequest__SendAsync_Z524259A4(req_3, 60000), (_arg_1) => singleton.Bind(dep.PostSend(req_3, _arg_1), (_arg_2) => singleton.Return(new SveaDry_ResponseContainer(_arg_2))));
    }));
}

export function SveaDry_send(dep, method, headers, url, jsNode) {
    return runSynchronously(SveaDry_sendAsync(dep, method, headers, url, jsNode));
}

export function SveaDry_expectSuccess(response) {
    const response_2 = HttpResponse__EnsureSuccessStatusCode(response.ResponseContainer.Response);
}

export function SveaDry_Read_contain(prev, node) {
    return new SveaDry_ElementContainer(new Lazy(() => node), prev.ResponseContainer);
}

export function SveaDry_Read_load(response) {
    return new SveaDry_ElementContainer(new Lazy(() => {
        let str;
        const objectArg = get_UTF8();
        str = objectArg.getString(response.Response.Body);
        const _arg = stringToJson(str);
        return (_arg.tag === 1) ? toFail(printf("Failed to parse json \u0027%s\u0027 - \u0027%s\u0027"))(_arg.fields[0])(str) : _arg.fields[0];
    }), response);
}

export function SveaDry_Read_parseDecimal(str) {
    return parse_2(str);
}

export function SveaDry_Read_string(n) {
    const _arg = n.Node.Value;
    if (_arg.tag === 0) {
        return _arg.fields[0];
    }
    else {
        return toFail(printf("Expected a string got %A"))(_arg);
    }
}

export function SveaDry_Read_int32(n) {
    const _arg = n.Node.Value;
    const activePatternResult = $007CJSInt$007C_$007C(_arg);
    if (activePatternResult != null) {
        const str = activePatternResult | 0;
        return str | 0;
    }
    else {
        return toFail(printf("Expected a int got %A"))(_arg) | 0;
    }
}

export function SveaDry_Read_int64(n) {
    const _arg = n.Node.Value;
    if (_arg.tag === 1) {
        return parse_3(_arg.fields[0], 511, false, 64);
    }
    else {
        return toFail(printf("Expected a int64 got %A"))(_arg);
    }
}

export function SveaDry_Read_prop(isRequired, name, n) {
    const _arg = n.Node.Value;
    if (_arg.tag === 2) {
        const matchValue = JSObject__tryFind_Z721C83C5(_arg.fields[0], name);
        if (matchValue == null) {
            if (isRequired) {
                return toFail(printf("Property \u0027%s\u0027 not found"))(name);
            }
            else {
                return SveaDry_Read_contain(n, new JSVal(5));
            }
        }
        else {
            return SveaDry_Read_contain(n, matchValue);
        }
    }
    else {
        return toFail(printf("Expected a obj got %A"))(_arg);
    }
}

export function SveaDry_Read_optional(fn, n) {
    const matchValue = n.Node.Value;
    if (matchValue.tag === 5) {
        return void 0;
    }
    else {
        return some(fn(SveaDry_Read_contain(n, matchValue)));
    }
}

export function SveaDry_Read_decimal(n) {
    const _arg = n.Node.Value;
    if (_arg.tag === 1) {
        return SveaDry_Read_parseDecimal(_arg.fields[0]);
    }
    else {
        return toFail(printf("Expected a number got %A"))(_arg);
    }
}

export function SveaDry_Read_boolean(n) {
    const _arg = n.Node.Value;
    if (_arg.tag === 4) {
        return _arg.fields[0];
    }
    else {
        return toFail(printf("Expected a boolean got %A"))(_arg);
    }
}

export function SveaDry_Read_array(fn, n) {
    const matchValue = n.Node.Value;
    if (matchValue.tag === 3) {
        return map_3((x) => fn(SveaDry_Read_contain(n, x)), matchValue.fields[0]);
    }
    else {
        return toFail(printf("Expected an array got %A"))(matchValue);
    }
}

export function SveaDry_Read_unit(n) {
}

export function SveaDry_Write_contain(node) {
    return new SveaDry_WriteContainer(node);
}

export function SveaDry_Write_object(items) {
    return SveaDry_Write_contain(JSObj_ofList(toList(map_1((tupledArg) => [tupledArg[0], tupledArg[1].Node], items))));
}

export function SveaDry_Write_string(s) {
    return SveaDry_Write_contain(new JSVal(0, s));
}

export function SveaDry_Write_int32(s) {
    return SveaDry_Write_contain(JSInt(s));
}

export function SveaDry_Write_int64(s) {
    return SveaDry_Write_contain(new JSVal(1, toString_2(s)));
}

export function SveaDry_Write_decimal(s) {
    return SveaDry_Write_contain(new JSVal(1, s.toString()));
}

export function SveaDry_Write_boolean(s) {
    return SveaDry_Write_contain(new JSVal(4, s));
}

export function SveaDry_Write_unit() {
    return SveaDry_Write_contain(new JSVal(5));
}

export function SveaDry_Write_optional(fn, s) {
    if (s == null) {
        return SveaDry_Write_contain(new JSVal(5));
    }
    else {
        return fn(value_3(s));
    }
}

export function SveaDry_Write_array(fn, s) {
    return SveaDry_Write_contain(new JSVal(3, toList(map_1((x) => fn(x).Node, s))));
}

